var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-pagination',{attrs:{"value":_vm.page,"length":_vm.totalPages,"total-visible":11,"disabled":_vm.disabled,"circle":"","color":"#EDA341 !important"},on:{"input":_vm.changePage}})
}
var staticRenderFns = []

export { render, staticRenderFns }